<template>
  <b-modal
    id="hospitalization-confirm-animal-death-modal"
    :title="isDead ? 'Êtes-vous sûr de vouloir indiquer que l\'animal est décédé ?'
                   : 'Vous avez indiqué que l\'animal était décédé, souhaitez-vous modifier cette information ?'"
    @ok="handleOk"
    ok-title="Confirmer"
    ok-variant="success rounded"
    cancel-title="Annuler"
    cancel-variant="primary rounded"
  >
  </b-modal>
</template>

<script>
import api from '../../services/api';
export default {
  name: "HospitalizationConfirmAnimalDeathModal",

  props: {
    isDead: {
      type: Boolean,
      required: true
    },
    animal: {
      type: Object,
      required: true,
    }
  },

  methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let data = new FormData()
      data.append('isDead', this.isDead)
      data.append('animalId', this.animal.id)

      api({
        method: 'POST',
        url: '/animal/setIsDead',
        data: data
      })
        .then(response => {
          this.hideModal()
          this.successToast(`Information enregistrée`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('hospitalization-confirm-animal-death-modal')
      this.$emit("onAnimalDeathConfirmed")
    },

    successToast(message) {
      this.$bvToast.toast(message, {
          autoHideDelay: 2000,
          toaster: 'b-toaster-bottom-right',
          noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationConfirmAnimalDeathModal.vue